import Flow from 'types/Flow';
import FlowsByModel from 'types/FlowsByModel';
import { ShareboxModel } from 'types/KioskTypes';

import { createDictionary } from 'utils/objectUtils';

import SHAREBOX_M28_CHECK_IN_STEPS from './m28';
import SHAREBOX_W64_CHECK_IN_STEPS from './w64';
import SHAREBOX_S32_PLUS_CHECK_IN_STEPS from './s32_plus';
import SHAREBOX_I32_CHECK_IN_STEPS, { ShareboxI32CheckInSteps } from './i32';
import SHAREBOX_S32_CHECK_OUT_STEPS, { ShareboxS32CheckInSteps } from './s32';

type ShareboxKioskFlow = Flow<ShareboxI32CheckInSteps> | Flow<ShareboxS32CheckInSteps>;

const SHAREBOX_KIOSK_CHECK_IN_STEPS = createDictionary<ShareboxModel, ShareboxKioskFlow>({
  [ShareboxModel.I32]: SHAREBOX_I32_CHECK_IN_STEPS,
  [ShareboxModel.W64]: SHAREBOX_W64_CHECK_IN_STEPS,
  [ShareboxModel.S32]: SHAREBOX_S32_CHECK_OUT_STEPS,
  [ShareboxModel.M28]: SHAREBOX_M28_CHECK_IN_STEPS,
  [ShareboxModel.S32_PLUS]: SHAREBOX_S32_PLUS_CHECK_IN_STEPS,
}, SHAREBOX_I32_CHECK_IN_STEPS) as FlowsByModel<ShareboxModel>;

export default SHAREBOX_KIOSK_CHECK_IN_STEPS;
